import { View } from 'foundations-components/components/View';
import HsocMerchCardGrid from './HsocMerchCardGrid';
import { jsx as _jsx } from "react/jsx-runtime";
export const HsocV2PricingPage = ({
  cards,
  onTermChange
}) => {
  return /*#__PURE__*/_jsx(View, {
    padding: "800",
    "data-selenium-id": "page-success",
    children: cards && cards.length > 0 ? /*#__PURE__*/_jsx(HsocMerchCardGrid, {
      cards: cards,
      onTermChange: onTermChange
    }) : null
  });
};